import React, { useEffect, useState } from 'react';
import { FormGroup, Label } from 'reactstrap';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import axios from "axios";
import { API_URL } from 'helpers/app_url';
import Moment from 'react-moment';
import moment from 'moment';


async function fetchBuyerDeals(clientId) {
  try {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;

    const url = `${API_URL}ClientEngagement/allbyselectedtypesstatus`;

    const body = {
      clientId: parseInt(clientId),
      agentId: parseInt(localStorage.getItem("userId")),
      statusIds: [1,2],
      typeId: 1,
    };

    const response = await axios.post(url, body, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching buyer deals:", error);
    return [];
  }
}

const FilterBuyerDeal = ({ clientId, onChange  }) => {
 
  const [clientengagements, setEngagements] = useState([]);

  useEffect(() => {
    if (clientId) {
      fetchBuyerDeals(clientId).then((data) => {
        setEngagements(data);
      });
    }
  }, [clientId]);

  const getType = (type) => type === 1 ? 'Rent' : type === 2 ? 'Purchase' : 'Unknown Type';
  const getSType = (type) => type === 1 ? 'Sell' : type === 2 ? 'Lease' : 'Unknown Type';

  const formatYYMM = (dateStr) => {
    if (!dateStr) return "0000";
    const date = new Date(dateStr);
    const yy = String(date.getFullYear()).slice(2);
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    return moment(dateStr).format('DD MMM YYYY');
  };

 

  return (
    
      <select
        name="filterDeal"
       className="form-select select-filter"
       onChange={(e) => onChange && onChange(e.target.value)} 
      >
       

         <option value="">All Deals</option>

        {clientengagements?.map(option => {
        
          const label = option.isBuyer
            ? `${getType(option.buyerType)} - (${option.id} - ${formatYYMM(option.lastAgreementDate)})`
            : ``;

          return (
            <option key={option.id} value={option.id}>
              {label}
            </option>
          );
        })}
      </select>
    
  );
};

FilterBuyerDeal.propTypes = {

  clientId: PropTypes.string.isRequired,
 onChange: PropTypes.func

};

export default FilterBuyerDeal;
